module.exports = __webpack_public_path__ + "img/bory_druzstevne-byvanie_ikony_prebratie_bytu.988b78b1.svg";